module.exports = __webpack_public_path__ + "img/fk4151_top_001.6bc6500b.png";